import { Chip, Tooltip } from "@mui/material";
import Iconify from "../Iconify/Iconify";

/**
 * FRONTEND_HANDOFF.md §1 — verificationLevel ve kyc_status için ortak rozetler.
 * Seviye backend'de phone_verified + kyc_status'tan türetilir, burada sadece okunur.
 */

type ChipColor = "default" | "warning" | "success" | "error" | "info";

const LEVEL_META: Record<string, { label: string; color: ChipColor }> = {
  ANONYMOUS: { label: "Anonim", color: "default" },
  STANDARD: { label: "Standart", color: "warning" },
  FULL: { label: "Tam", color: "success" },
};

const KYC_META: Record<string, { label: string; color: ChipColor }> = {
  not_started: { label: "Başlamadı", color: "default" },
  pending: { label: "Bekliyor", color: "warning" },
  processing: { label: "İşleniyor", color: "info" },
  approved: { label: "Onaylandı", color: "success" },
  declined: { label: "Reddedildi", color: "error" },
  needs_review: { label: "İnceleme gerekli", color: "warning" },
  expired: { label: "Süresi doldu", color: "default" },
};

export const KYC_STATUSES = Object.keys(KYC_META);
export const VERIFICATION_LEVELS = Object.keys(LEVEL_META);

export const kycStatusLabel = (status?: string) =>
  KYC_META[status ?? ""]?.label ?? status ?? "-";

export const VerificationLevelChip = ({ level }: { level?: string }) => {
  const meta = LEVEL_META[level ?? ""];

  if (!meta) return <Chip size="small" label={level ?? "-"} />;

  return <Chip size="small" color={meta.color} label={meta.label} />;
};

export const KycStatusChip = ({ status }: { status?: string }) => {
  const meta = KYC_META[status ?? ""];

  if (!meta)
    return <Chip size="small" variant="outlined" label={status ?? "-"} />;

  return (
    <Chip
      size="small"
      variant="outlined"
      color={meta.color}
      label={meta.label}
    />
  );
};

/**
 * Telefon numarası + doğrulanma durumu. Numara yoksa sadece "-" gösterilir.
 */
export const PhoneVerifiedCell = ({
  phone,
  verified,
}: {
  phone?: string;
  verified?: boolean;
}) => {
  if (!phone) return <>-</>;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      {phone}
      <Tooltip title={verified ? "Telefon doğrulandı" : "Telefon doğrulanmadı"}>
        <span style={{ display: "inline-flex" }}>
          <Iconify
            icon={
              verified ? "eva:checkmark-circle-2-fill" : "eva:close-circle-fill"
            }
            sx={{
              width: 16,
              height: 16,
              color: verified ? "success.main" : "text.disabled",
            }}
          />
        </span>
      </Tooltip>
    </span>
  );
};
